<template>
  <div class="messages">
    <box :title="$t('messages-list')">
      <div v-if="messages.length > 0">
        <v-data-table
          dense
          :disable-sort="true"
          :headers="headers"
          hide-default-footer
          disable-pagination
          :items="messages"
          item-key="MessageId"
          group-by="Sender"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th class="group-header" :colspan="headers.length">
              <div>
                <v-icon @click="toggle"
                  >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
                {{ items[0].Sender }}
              </div>
            </th>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <strong v-if="item.ReadDate == ''">{{ item.Subject }}</strong>
                <span v-else>{{ item.Subject }}</span>
              </td>
              <td>{{ item.SentDate }}</td>
              <td>{{ item.ReadDate }}</td>
              <td @click="showMessage(item)">
                <v-btn text>{{ $t("show") }}</v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
    <message-dialog ref="MessageDialog"/>
  </div>
</template>

<script>
import MessageDialog from '../../components/messages/MessageDialog.vue';
import EmptyList from "../../components/widget/EmptyList.vue";
import ResultType from "../../model/ResultType";
import ArrayUtils from "../../utils/ArrayUtils";
export default {
  components: {
    EmptyList,
    MessageDialog,
  },
  data() {
    return {
      groupMessages: [],
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: this.$t("Subject"),
          value: "Subject",
        },
        {
          text: this.$t("SentDate"),
          value: "SentDate",
        },
        {
          text: this.$t("ReadDate"),
          value: "ReadDate",
        },
        {
          text: "",
          value: "show",
        },
      ],
    };
  },
  props: { messages: Array },
  mounted() {
    this.GetInbox();
  },
  methods: {
    GetInbox() {
      debugger
      if (this.messages.length > 0) {
        var obj = ArrayUtils.groupBy(this.messages, "Sender");
        var arr = [];
        Object.keys(obj).forEach((key) => {
          var item = { key: key, group: obj[key] };
          arr.push(item);
        });
        this.groupMessages = arr;
      }
    },
    showMessage(item) {
      debugger
      console.log(item);
      this.$refs.MessageDialog.show(item);
      this.$store.dispatch("MarkAsRead", item.MessageId).then((result) => {
        console.log(result);
        if (result.type == ResultType.success) {
          this.$emit("refresh");
        }
      });
    },
  },
};
</script>

<style scoped>
.group-header {
  background: #ededed !important;
}
</style>